var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 327.1 327.1",
    style: {
      enableBackground: "new 0 0 327.1 327.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.7,327.1H75.4c-6.1-1.3-12.4-2-18.3-4c-34.4-11.2-56.9-42.1-57-78.3c-0.2-54.2-0.2-108.4,0-162.6 c0-17.5,4.9-33.6,15.3-47.8C32.3,11.5,55.3,0.1,83.9,0C136.5,0,189.2,0,242,0c5.5-0.1,11.1,0.3,16.5,1.2c30.2,5.5,51.3,22.7,62.8,51 c3,7.3,3.9,15.3,5.8,23.1v176.4c-0.4,2.3-0.8,4.6-1.2,6.8c-5.6,30-22.7,51-50.8,62.6C267.7,324.3,259.5,325.2,251.7,327.1z  M299.7,163.6h0.1c0-26.6,0-53.2,0-79.9c0-8.5-1.1-16.8-4.9-24.5c-10.3-20.8-27.1-31.8-50.4-31.9c-54-0.2-108-0.1-161.9,0 c-3.2,0-6.4,0.3-9.5,0.8c-24.8,3.5-45.3,25.9-45.4,51c-0.4,55.6-0.2,111.3-0.2,167c-0.1,7.5,1.6,14.9,4.8,21.6 c10.5,21.2,27.6,32,51.3,32c53.3,0.1,106.7,0.1,160,0c3.6,0,7.2-0.3,10.8-0.8c24.3-3.3,45-26,45.3-50.5 C300,220.2,299.7,191.9,299.7,163.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.2,245.4c-45.3-0.4-81.9-37.5-81.4-82.3c0.6-45.2,37.3-81.6,82.1-81.2c45.3,0.4,81.9,37.5,81.4,82.3 C244.8,209.3,208,245.7,163.2,245.4z M163.6,218c30.1,0,54.4-24.4,54.4-54.5s-24.4-54.4-54.5-54.4s-54.4,24.4-54.4,54.5v0.1 c0,30,24.4,54.3,54.4,54.3C163.6,218,163.6,218,163.6,218L163.6,218z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252,95.3c-11.3-0.3-20.1-9.7-19.8-21c0.3-10.9,9.2-19.7,20.1-19.8c11.3-0.2,20.5,8.9,20.7,20.1s-8.9,20.5-20.1,20.7 C252.6,95.3,252.3,95.3,252,95.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c71334cb2f1b15bc88e52371a0f406db.svg";
export { ForwardRef as ReactComponent };